module.exports = __webpack_public_path__ + "img/cha.24492431.png";